import React, { useState, useRef, useEffect } from "react";

import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import { addData, getAllData } from "../../../Utility/API";
import { useSelector, useDispatch } from "react-redux";
import AccessListSearch from "../../../components/FilterComponent/AccessListSearch";
import { CopyToClipboard } from 'react-copy-to-clipboard';

function getNumberOfPages(rowCount, rowsPerPage) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages) {
  const results = [];
  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}
const columns = [
  {
    name: "Session ID",
    selector: (row) => row.idUser,
    sortable: true,
  },
  {
    name: "Session code",
    selector: (row) => row.sessionCode,
    sortable: true,
  },
  {
    name: "Player",
    selector: (row) => row.login,
    sortable: true,
  },
  {
    name: "Start",
    selector: (row) => row.startTime,
    sortable: true,
  },
  {
    name: "End",
    selector: (row) => row.endTime,
    sortable: true,
  },
  {
    name: "Device",
    selector: (row) => row.device,
    sortable: true,
  },
  {
    name: "Device Id ",
    selector: (row, index) => {
      return <CopyToClipboard text={row.deviceId} style={{ cursor: 'pointer' }}>
        <span>{row.deviceId}</span>
      </CopyToClipboard>

    },
    sortable: true,
  },
  {
    name: "Browser",
    selector: (row) => row.browser,
    sortable: true,
  },
  {
    name: "Platform ",
    selector: (row) => row.operatingSystem,
    sortable: true,
  },
  {
    name: "IP address",
    selector: (row) => row.ipAddress,
    sortable: true,
  },
  {
    name: "Initial balance",
    selector: (row) => row.balanceStart,
    sortable: true,
  },
  {
    name: "Final balance",
    selector: (row) => row.balanceEnd,
    sortable: true,
  }
  // {
  //     name: "Played",
  //     selector: (row) => row.played,
  //     sortable: true,
  // }
];
// RDT exposes the following internal pagination properties
const BootyPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage, // available but not used here
  currentPage
}) => {
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            Previous
          </button>
        </li>
        {pageItems.map((page) => {

          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

const AccessList = () => {
  const [pending, setPending] = useState(true);
  const [rows, setRows] = useState([]);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const filteredItems = rows.filter(
    (item) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );
  const state = useSelector((state) => state);

  const { auth, sidebar } = state;

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    let url = `${endPoints.api.GET_Access_List}`;
    let data = {
      "userId": 0,
      "agencyId": 0,
      "operatorId": 0,
      "showRiskmanager": true,
      "logoutType": 0,
      "sessionCode": "string",
      "sessionId": 0,
      "pagination": {
        "pageSize": 0,
        "pageNumber": 0,
        "maxLimit": 100
      },
      "fromDate": "2022-06-10T16:31:57.262Z",
      "toDate": "2022-06-10T16:31:57.262Z"
    }
    console.log("auth", auth);
    await addData(url, data)
      .then((response) => {

        if (response.status == 200) {
          setRows(response.data.data);
          setPending(false);

        } else {
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <>
      <div className="main">
        <div id="Sportbook" style={{ padding: '0px' }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-4">Access List</h2>
                </div>
              </div>
              <div
                className="row"
                style={{ padding: "5px 0px 20px 0px" }}
              >
                <div className="col-md-12">
                  <AccessListSearch />
                </div>
                <div className="container-fluid table-custom">
                  <div className="col-md-12">
                    <DataTable
                    className="c_table"
                      title=""
                      columns={columns}
                      data={rows}
                      defaultSortFieldID={1}
                      pagination
                      paginationComponent={BootyPagination}
                      paginationResetDefaultPage={resetPaginationToggle} // optionally, a hook to reset pagination to page 1
                    // subHeader
                    // subHeaderComponent={subHeaderComponentMemo}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessList;
